export const KEY_LOCAL_STORAGE_TOKEN = 'token'
export const KEY_LOCAL_STORAGE_USER_INFO = 'user_info'
